import { AbstractSummaryCellProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSummaryCellProperties";
import * as PIXI from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameTextUtil } from "../../../utils/GameTextUtil";
import { GameFontStyle } from "../style/GameFontStyle";
/**
 * Game-specific properties for a summary cell.
 */
export class GameSummaryCellProperties extends AbstractSummaryCellProperties {
    constructor(iconAsset, nameLangKey, currency) {
        super(iconAsset, nameLangKey, currency);
        this.nameFieldProperties.size = new PIXI.Point(250, 75);
        this.amountFieldProperties.styleId = GameFontStyle.GAME_SUMMARY_CELL_VALUE;
        this.amountFieldProperties.fontProperties = this.amountFieldProperties.getFont(this.amountFieldProperties.styleId);
        this.amountFieldProperties.size = new PIXI.Point(240, 85);
        this.backgroundProperties.position = new PIXI.Point(0, 0);
        this.iconProperties.position = new PIXI.Point(-125, 0);
        this.amountFieldProperties.position.y -= 4; //Spine slot is centered, but the font means it needs to be moved up a little
        this.nameFieldProperties.position.y -= 4;
        this.size = new PIXI.Point(900, 100);
        GameTextUtil.centerProperties(this.nameFieldProperties, this.amountFieldProperties);
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameSummaryCellProperties.js.map